import { useNavigate, useSearchParams } from 'react-router-dom'
import { KTCard, Permission, showError } from '../../../../../_metronic/helpers'
import { useCallback, useEffect, useState } from 'react'
import { getFormularioById, getFormularioOfEmpresaById } from './core/_requests'
import { FormularioView } from './core/_models'
import { Button, ListLoading } from '../../../../components'
import { useAuth } from '../../../auth'
import { FormularioEdit } from './component/formulario-edit/FormularioEdit'

const FormularioCreate = () => {
  const [searchParams] = useSearchParams()
  const { currentUser } = useAuth()
  const navigate = useNavigate()

  const id = Number(searchParams.get('id'))
  const isAdmin = currentUser?.grupo?.nome === Permission.Admin

  const [formulario, setFormulario] = useState<FormularioView>()
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [notFound, setNotFound] = useState<boolean>(false)
  /** Muda a cada recarga para reinicializar o estado local do construtor. */
  const [versao, setVersao] = useState<number>(0)

  const carregar = useCallback(async () => {
    try {
      setIsLoading(true)
      if (id) {
        const form = isAdmin ? await getFormularioOfEmpresaById(id) : await getFormularioById(id)
        setFormulario(form)
        setVersao((anterior) => anterior + 1)
      }
    } catch (error) {
      setNotFound(true)
      showError(error)
    } finally {
      setIsLoading(false)
    }
  }, [id, isAdmin])

  useEffect(() => {
    carregar()
  }, [carregar])

  const aguardandoPrimeiraCarga = !!id && !formulario

  return (
    <KTCard>
      {isLoading && <ListLoading />}
      {!(isLoading && aguardandoPrimeiraCarga) &&
        (notFound ? (
          <div className='d-flex flex-column align-items-center py-20'>
            <h3 className='mb-3'>Formulário não encontrado</h3>
            <span className='text-muted mb-6'>
              O formulário que você está tentando editar não existe ou foi removido.
            </span>
            <Button className='btn-primary' onClick={() => navigate('/apps/formularios')}>
              Voltar para a lista
            </Button>
          </div>
        ) : (
          <FormularioEdit
            key={`formulario-${id}-${versao}`}
            formulario={formulario}
            somenteLeitura={!!formulario?.bloqueado}
            onRecarregar={carregar}
          />
        ))}
    </KTCard>
  )
}

export const FormularioCreateWrapper = () => <FormularioCreate />
